import { render, staticRenderFns } from "./CompareTableItem.vue?vue&type=template&id=5a0cb942&scoped=true&"
import script from "./CompareTableItem.vue?vue&type=script&lang=js&"
export * from "./CompareTableItem.vue?vue&type=script&lang=js&"
import style0 from "./CompareTableItem.vue?vue&type=style&index=0&id=5a0cb942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0cb942",
  null
  
)

export default component.exports